import React, { useState } from 'react';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import { jsPDF } from 'jspdf';
import XLSX from 'sheetjs-style';
import 'jspdf-autotable';
import 'assets/css/table.css';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import moment from 'moment';
import Axios from 'axios';

import dateformat from 'dateformat';
import common from '../../../commonData';
import NavMenu from './navbar';
import ActionBtn from './gridactionbtn';
import AddFacture from './addFacture';
import AddSortie from './addSortie';
import NumberToLetter from '../../../converter';
import FilterModale from './filterModal';
import FacturerModal from './facturerModal';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter';

function IndexProforma({
    rows,
    keys,
    setIsSave,
    setMsg,
    setMsgravity,
    setShowFilterModals,
    actualise,
    setActualise,
    setDatasProf,
    paramShow,
    getFacture,
    getProforma,
    clients
}) {
    const [selected, setSelected] = useState({});
    const [load, setLoad] = useState(false);
    const [isLoading, setIsLoad] = useState(false);
    const [datafacture, setDatafacture] = useState([]);
    const [gridRef, setGridRef] = useState(null);
    const [filterDate, setFilterDate] = useState({});
    const [statesParent, setState] = useState({});
    const [ids, setId] = useState(0);

    const [showFactureModal, setShowFactureModal] = useState(false);
    // const [shows, setShows] = useState(false);
    const [showAddLiv, setShowAddLiv] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showFactureForm, setShowFactureForm] = useState(false);
    // useState({
    //     nobon: null,
    //     datet: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
    //     sitva: '0',
    //     type: 'Proforma',
    //     clientid: '',
    //     engin: '',
    //     listeSelect: [],
    //     sortie: null,
    //     type_remise: 0,
    //     remise_main: 0
    // });
    const gridStyle = { minHeight: window.screen.height - 200 };

    const filterValuePro = [
        // { name: 'nofact', operator: 'contains', type: 'string', value: '' },
        // { name: 'nomclient', operator: 'contains', type: 'string', value: '' },
        { name: 'nomclient', operator: 'inlist', type: 'select', value: [] },
        { name: 'noprof', operator: 'contains', type: 'string', value: '' },
        { name: 'dateprof', operator: 'inrange', type: 'date', value: null },
        { name: 'username', operator: 'contains', type: 'string', value: '' },
        { name: 'userupdate', operator: 'contains', type: 'string', value: '' },
        { name: 'silivrer', operator: 'contains', type: 'string', value: '' }
        // { name: 'montantfacture', operator: 'gte', type: 'number', value: 0 }
        // { name: 'prix_ht', operator: 'gte', type: 'number', value: 0 },
        // { name: 'prix_tva', operator: 'gte', type: 'number', value: 0 },
        // { name: 'remise', operator: 'gte', type: 'number', value: 0 },
        // { name: 'reglement', operator: 'gte', type: 'number', value: 0 }
        // { name: 'reste', operator: 'gte', type: 'number', value: 0 }
    ];
    const columnPro = [
        {
            name: 'id',
            header: 'Id',
            defaultVisible: false,
            defaultWidth: 80,
            type: 'number'
        },
        {
            header: 'Action',
            defaultWidth: 130,
            type: 'string',
            render: ({ value, data }) => (
                <ActionBtn
                    data={data}
                    handleShow={handleShow}
                    // EditFacture={EditFacture}
                    printFacture={printFacture}
                    setShowAddOrEdit={setShowAddOrEdit}
                    onDelete={onDelete}
                    // printBl={printBl}
                    // setShowAdds={setShowFactureForm}
                />
            )
        },
        {
            name: 'silivrer',
            header: 'Statut',
            defaultWidth: 100,
            type: 'string',
            textAlign: 'center',
            render: ({ data }) => (
                <p id={data.silivrer === 'Livrer' ? 'successs' : 'success'}>
                    <a onClick={(e) => setShowAdds(data)}>{data.silivrer}</a>
                </p>
            )
        },
        { name: 'noprof', header: 'N° proforma', defaultWidth: 90, type: 'string' },

        {
            name: 'dateprof',
            header: 'Date proforma',
            defaultWidth: 200,
            type: 'date',
            dateFormat: 'DD-MM-YYYY',
            textAlign: 'center',
            filterEditor: DateFilter,
            filterEditorProps: (props, { index }) => {
                // for range and notinrange operators, the index is 1 for the after field
                return {
                    dateFormat: 'DD-MM-YYYY',
                    placeholder: index === 1 ? 'Date fin' : 'Date début'
                };
            },
            render: ({ value, cellProps: { dateFormat } }) => (value ? moment(value).format(dateFormat) : 'Néant')
        },
        {
            name: 'nomclient',
            header: 'Clients',
            defaultWidth: 170,
            type: 'string',
            filterEditor: SelectFilter,
            filterEditorProps: {
                multiple: true,
                wrapMultiple: false,
                dataSource: clients.map((c) => {
                    return { id: c.raisonsocial, label: c.raisonsocial };
                })
            }
        },
        {
            // name: 'montantfacture',
            header: 'Remise',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[3] || 0)
        },
        {
            // name: 'montantfacture',
            header: 'Mont. HT',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[0] || 0)
        },
        {
            // name: 'montantfacture',
            header: 'Mont. TVA',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[1] || 0)
        },
        {
            // name: 'montantfacture',
            header: 'Mont. TTC',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[2] || 0)
        },
        {
            name: 'montantavoir',
            header: 'Avoir',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => common.numberformat(value)
        },
        {
            name: 'montantreglemnt',
            header: 'Mont. payé',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => common.numberformat(value)
        },
        {
            // name: 'montantreglemnt',
            header: 'Reste à payé',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[2] - data.montantreglemnt)
        },
        { name: 'username', header: 'Crée par', defaultWidth: 100, type: 'string' },
        {
            name: 'created_at',
            header: 'Crée le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformat(value, 'dd-mm-yyyy HH:MM')
        },
        { name: 'userupdate', header: 'Modif. par', defaultWidth: 100, type: 'string' },
        {
            name: 'updated_at',
            header: 'Modif. le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformat(value, 'dd-mm-yyyy HH:MM')
        }
    ];

    function setShowFilterModals(param) {
        setShowFilterModal(true);
    }
    const handleClose = () => {
        // setShow(false);
        // setShowFactureForm(false);
        setShowFilterModal(false);
    };
    function handleShow(d) {
        // setNoprof(d[1]);
        // setFactid(d[0]);
        // setDateprof(dateformat(d[2], 'yyyy-mm-dd'));
        setDatafacture(d);
        setShowFactureModal(true);
        // setShowFactureForm(true);
    }

    // function EditFacture(ids, typm) {
    //     setLoad(true);
    //     Axios.get(common.ipapi + '/api/facture/edit/' + ids).then((response) => {
    //         setLigneFacture(response.data.lignefacture);
    //         setFact(response.data.nofact == 0 || response.data.nofact == null ? response.data.noprof : response.data.nofact);
    //         setClient(response.data.client ? response.data.client.raisonsocial : '');
    //         setDatesort(
    //             response.data.datefact == null
    //                 ? dateformat(response.data.dateprof, 'yyyy-mm-dd')
    //                 : dateformat(response.data.datefact, 'yyyy-mm-dd')
    //         );
    //         setShows(true);
    //         // setTypeModal(typm);
    //         setLoad(false);
    //     });
    // }

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        };
    }

    function setShowAdds(data) {
        setDatafacture(data);
        setShowAddLiv(true);
    }

    // Supprimer une facture proforma
    async function onDelete(id, nofac) {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'SFAC');
        if (log == undefined) {
            if (log1 == undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
        }
        if (window.confirm('Voulez-vous supprimer cette ligne ?')) {
            setLoad(true);
            setIsLoad(true);

            await Axios.delete(common.ipapi + '/api/facture/destroy/' + id).then((response) => {
                if (response.data.status === 1) {
                    const del = rows.filter((d) => d.id != id);
                    setDatasProf(del);

                    setMsg(response.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    setLoad(false);
                    setIsLoad(false);
                } else {
                    setMsgravity('danger');
                    setMsg(response.data.msg);
                    setIsSave(true);
                    setLoad(false);
                    setIsLoad(false);
                }
            });
        }
    }

    function setShowAddOrEdit(id) {
        if (id) {
            Axios.get(common.ipapi + '/api/facture/edit/' + id)
                .then((response) => {
                    if (response.data) {
                        setState(response.data);
                        // setState({
                        //     nobon: response.data.nofact == 0 || response.data.nofact == null ? response.data.noprof : response.data.nofact,
                        //     datet:
                        //         response.data.nofact == 0 || response.data.nofact == null
                        //             ? dateformat(response.data.dateprof, 'yyyy-mm-dd')
                        //             : dateformat(response.data.datefact, 'yyyy-mm-dd'),
                        //     sitva: response.data.sitva,
                        //     type: response.data.nofact == null || response.data.nofact == 0 ? 'Proforma' : 'Facture',
                        //     clientid: response.data.client_id,
                        //     engin: response.data.engin,
                        //     listeSelect: response.data.lignefacture.length > 0 ? groupBy(response.data.lignefacture) : [],
                        //     sortie: response.data.sortie,
                        //     type_remise: response.data.type_remise,
                        //     remise_main: response.data.remise_main
                        // });
                        setId(id);
                        setShowFactureForm(true);
                    }
                    setLoad(false);
                })
                .catch((errors) => {
                    setLoad(false);
                });
        } else {
            // setState
            // ({
            //     nobon: null,
            //     datet: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
            //     sitva: '0',
            //     type: 'Proforma',
            //     clientid: '',
            //     engin: '',
            //     listeSelect: [],
            //     sortie: null,
            //     type_remise: 0,
            //     remise_main: 0
            // });
            setId(0);
            setState({});
            setShowFactureForm(true);
        }
    }

    //------- IMPRIMER FACTURE -----------------
    async function printFacture(id) {
        let text =
            'Voulez-vous imprimer avec ou sans entête ? \n Ok si vous voulez avec entête \n Annuler si vous ne voulez pas avec entête';
        let res = window.confirm(text);
        var doc = new jsPDF();
        var width = doc.internal.pageSize.getWidth();
        var dataFactures = [];
        var data = [];
        var resp = [];
        var i = 0;
        var h = 0;
        let mont = 0;
        let t = 0;
        let montht = 0;
        let montbrut = 0;
        let remis = 0;
        let remisChange = false;
        var siremise = false;
        let valremise = 0;
        setLoad(true);
        var type_remise = 0;
        var remise_main = 0;
        var val_remise = 0;
        await Axios.get(common.ipapi + '/api/facture/edit/' + id)
            .then((responses) => {
                resp = resp.concat(responses.data);

                responses.data.lignefacture.forEach((row) => {
                    h += row.pivot.prix * row.pivot.quantite;
                    type_remise = responses.data.type_remise;
                    remise_main = responses.data.remise_main;
                    if (row.pivot.remise != 0) {
                        siremise = true;
                    }
                    if (remise_main > 0) {
                        // if (type_remise == 0) {
                        siremise = true;
                        // }
                    }
                    valremise = responses.data.lignefacture[0].pivot.remise;
                    if (responses.data.lignefacture[0].pivot.remise != row.pivot.remise) {
                        remisChange = true;
                    }
                    var remisevalue =
                        responses.data.type_remise == 0 && responses.data.remise_main
                            ? row.pivot.prix * row.pivot.quantite * ((row.pivot.remise + responses.data.remise_main) / 100)
                            : row.pivot.prix * row.pivot.quantite * (row.pivot.remise / 100);
                    data.push({
                        descriptionart: row.pivot.descriptionart || row.descriptionartfr,
                        quantite: row.pivot.quantite,
                        prix: row.pivot.prix,
                        siremise: row.pivot.remise,
                        pourcentremise:
                            responses.data.client && responses.data.client.remise
                                ? responses.data.client.remise.pourcentage
                                : row.pivot.remise,
                        // remis: row.pivot.prix * row.pivot.quantite * (row.pivot.remise / 100),
                        remis: remisevalue,
                        t: row.pivot.prix * row.pivot.quantite - remisevalue
                        // responses.data.client && responses.data.client.remise
                        //     ? row.pivot.prix * row.pivot.quantite -
                        //       row.pivot.prix * row.pivot.quantite * (responses.data.client.remise.pourcentage / 100)
                        //     : row.pivot.prix * row.pivot.quantite - row.pivot.prix * row.pivot.quantite * (row.pivot.remise / 100)
                    });
                });
                data.forEach((row) => {
                    montbrut += row.t + row.remis;
                    montht += row.t;
                    remis += row.remis;
                    siremise
                        ? remisChange
                            ? dataFactures.push([
                                  { content: row.descriptionart },
                                  { content: row.quantite },
                                  { content: common.formatCurrency(row.prix) },
                                  { content: row.pourcentremise },
                                  { content: Math.round(row.remis) },
                                  { content: common.formatCurrency(row.t) }
                              ])
                            : dataFactures.push([
                                  { content: row.descriptionart },
                                  { content: row.quantite },
                                  { content: common.formatCurrency(row.prix) },
                                  { content: Math.round(row.remis) },
                                  { content: common.formatCurrency(row.t) }
                              ])
                        : dataFactures.push([
                              { content: row.descriptionart },
                              { content: row.quantite },
                              { content: common.formatCurrency(row.prix) },
                              { content: common.formatCurrency(row.t) }
                          ]);
                });
                val_remise = remise_main > 0 ? (type_remise == 0 ? 0 : remise_main) : 0;
                montht -= val_remise;
                responses.data.sitva == 1 ? (mont = montht) : (mont = montht + montht * 0.18);
                // console.log(remise_main);
            })
            .catch((errors) => {
                setLoad(false);
            });
        if (res === true) {
            doc.setFillColor(255, 127, 0);
            common.societe === 0 ? doc.addImage(common.logo, 'png', 14, 10, 30, 30) : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);
            doc.setFontSize(16);
            doc.setFontSize(20);
            doc.setTextColor(0, 0, 0);
            doc.text('PROFORMA CLIENT', 113, 26);
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text(113, 43, 'Abidjan le: ' + dateformat(new Date(), 'dd/mm/yyyy'));
            doc.rect(110, 45, 86, 27);
            doc.text(resp[0].client ? 'Nom: ' + resp[0].client.raisonsocial : 'Nom: NEANT', 113, 50);
            doc.text(resp[0].client ? 'Télephone: ' + resp[0].client.telcli : 'Télephone: NEANT', 113, 55);
            doc.text('Compte contribuable: ' + resp[0].client.nocomptec, 113, 60);
            doc.text('N° proforma: ' + resp[0].noprof, 113, 65);
            doc.text('Date pièce: ' + dateformat(resp[0].dateprof, 'dd/mm/yyyy'), 113, 70);
            doc.text('Engin: ' + resp[0].engin, 15, 70);
            doc.setFontSize(10);
            if (remise_main > 0) {
                if (type_remise == 0) {
                    valremise = remise_main;
                }
            }
            doc.autoTable({
                styles: {
                    fillColor: [0, 0, 0],
                    textColor: [255, 255, 255],
                    lineColor: [0, 0, 0],
                    cellPadding: 1.25,
                    halign: 'center',
                    lineColor: [127, 143, 166]
                },
                columnStyles: siremise
                    ? remisChange
                        ? {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              5: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                        : {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                    : {
                          0: {
                              halign: 'left',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                didDrawCell: function (data) {
                    h = data.cell.y + 20;
                },
                theme: 'grid',
                startY: 75,
                fontSize: 9,
                margin: { bottom: 40 },
                head: siremise
                    ? remisChange
                        ? [['Article', 'Quantité', 'Prix unit.', 'Remise(%)', 'Mont. remise', 'Montant']]
                        : [['Article', 'Quantité', 'Prix unit.', 'Remise(' + valremise + '%)', 'Montant']]
                    : [['Article', 'Quantité', 'Prix unit.', 'Montant']],
                body: dataFactures
                //foot: [['Montant TTC','','','','','',common.formatCurrency(mont+mont*0.18)]],
            });
            if (remise_main > 0) {
                if (type_remise == 0) {
                    // doc.text('Remimse ' + remise_main + '%', 15, doc.lastAutoTable.finalY + 4);
                } else {
                    doc.text('Remise ' + remise_main + ' FCFA', 15, doc.lastAutoTable.finalY + 4);
                }
            }
            doc.autoTable({
                styles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    cellPadding: 0.8,
                    lineColor: [0, 0, 0],
                    halign: 'center'
                },
                columnStyles: siremise
                    ? {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          4: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      }
                    : {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                margin: { bottom: 40 },
                theme: 'grid',
                startY: doc.lastAutoTable.finalY + 9,
                head: siremise
                    ? [['TOTAL BRUT', 'REMISE', 'TOTAL NET', resp[0].sitva == 1 ? 'TVA EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']]
                    : [['TOTAL NET', resp[0].sitva == 1 ? 'TVA  EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']],
                body: siremise
                    ? [
                          [
                              common.formatCurrency(montbrut),
                              common.formatCurrency(remis + val_remise),
                              common.formatCurrency(montht),
                              common.formatCurrency(montht * 0.18),
                              common.formatCurrency(mont)
                          ]
                      ]
                    : [[common.formatCurrency(montht), common.formatCurrency(montht * 0.18), common.formatCurrency(mont)]]
            });
            var finalY = doc.lastAutoTable.finalY;
            if (finalY > 217) {
                doc.addPage();
            }
            const pageCount = doc.internal.getNumberOfPages();
            for (var u = 1; u <= pageCount; u++) {
                doc.setPage(u);
                doc.setFontSize(10);
                doc.text('Page ' + String(u) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
            }
            doc.text('Arrêté à la somme de:', 15, 229);
            doc.setFontSize(8);
            doc.text(NumberToLetter(Math.round(mont)).toUpperCase() + ' FCFA', 15, 236);
            doc.rect(14, 231, width - 28, 8);
            doc.setFontSize(10);
            doc.text('Visa direction:', 15, 246);
            // doc.rect(14, 247, 60, 22);
            doc.text('Visa client:', 135, 246);
            // doc.rect(135, 247, 60, 22);
            doc.setFontSize(8);

            doc.setLineWidth(1.5);
            doc.setFontSize(8);
            doc.setLineWidth(1.5);
            doc.setDrawColor(0, 0, 0);
            doc.line(0, 275, width, 275);
            doc.text(
                'Siège social - Marcory Boulevard de Marseille - Zone 4 - 26 BP 695 Abidjan 26 - Tel.: 27 21 36 39 79 / Fax: 27 21 34 59 59',
                105,
                280,
                null,
                'center'
            );
            doc.text(
                'RCCM N°CI-ABJ-2012-A-5995 - Compte SIB N° CI 007 0106885056950010020 / Cel: 07 08 29 40 40 /  Email: vicaso11@hotmail.fr ',
                105,
                285,
                null,
                'center'
            );
            doc.setFontSize(8);
            doc.setTextColor(254, 0, 0);
            // doc.text('* Aucun produit ne peut être retourner 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);
            if (common.societe === 0) {
                doc.text('* Aucun produit ne peut être retourné.', 14, doc.lastAutoTable.finalY + 3);
            } else {
                doc.text(
                    '* Cette proforma est valable une semaine à compter de sa date d’émission après cette date les prix peuvent changer.',
                    14,
                    doc.lastAutoTable.finalY + 3
                );
            }

            setLoad(false);
            //doc.autoPrint({variant: 'non-conform'});
            doc.save('proforma.pdf');
        } else {
            doc.setFillColor(255, 127, 0);
            doc.setFillColor(0, 0, 0);
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text(119, 60, 'Abidjan le: ' + dateformat(new Date(), 'dd/mm/yyyy'));
            doc.rect(115, 61, 81, 27);
            doc.text(resp[0].client ? 'Nom: ' + resp[0].client.raisonsocial : 'Nom: NEANT', 119, 66);
            doc.text(resp[0].client ? 'Télephone: ' + resp[0].client.telcli : 'Télephone: NEANT', 119, 71);
            doc.text('Compte contribuable: ' + resp[0].client.nocomptec, 119, 76);
            doc.text('N° proforma: ' + resp[0].noprof, 119, 81);
            doc.text('Date proforma: ' + dateformat(resp[0].dateprof, 'dd/mm/yyyy'), 119, 86);
            doc.text('Engin: ' + resp[0].engin, 15, 86);
            doc.setFontSize(10);

            doc.autoTable({
                styles: {
                    fillColor: [0, 0, 0],
                    textColor: [255, 255, 255],
                    lineColor: [0, 0, 0],
                    cellPadding: 1.25,
                    halign: 'center'
                },
                columnStyles: siremise
                    ? remisChange
                        ? {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              5: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                        : {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                    : {
                          0: {
                              halign: 'left',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                didDrawCell: function (data) {
                    h = data.cell.y + 20;
                },
                theme: 'grid',
                startY: 90,
                fontSize: 9,
                margin: { bottom: 40 },
                head: siremise
                    ? remisChange
                        ? [['Article', 'Quantité', 'Prix unit.', 'Remise(%)', 'Mont. remise', 'Montant']]
                        : [['Article', 'Quantité', 'Prix unit.', 'Remise(' + valremise + '%)', 'Montant']]
                    : [['Article', 'Quantité', 'Prix unit.', 'Montant']],
                body: dataFactures
            });
            if (remise_main > 0) {
                if (type_remise == 0) {
                    doc.text('Remise ' + remise_main + '%', 15, doc.lastAutoTable.finalY + 4);
                } else {
                    doc.text('Remise ' + remise_main + ' FCFA', 15, doc.lastAutoTable.finalY + 4);
                }
            }
            doc.autoTable({
                styles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    cellPadding: 0.8,
                    lineColor: [0, 0, 0],
                    halign: 'center'
                },
                columnStyles: siremise
                    ? {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          4: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      }
                    : {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                margin: { bottom: 35 },
                theme: 'grid',
                startY: doc.lastAutoTable.finalY + 9,
                head: siremise
                    ? [['TOTAL BRUT', 'REMISE', 'TOTAL NET', resp[0].sitva == 1 ? 'TVA EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']]
                    : [['TOTAL NET', resp[0].sitva == 1 ? 'TVA  EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']],
                body: siremise
                    ? [
                          [
                              common.formatCurrency(montbrut),
                              common.formatCurrency(remis + val_remise),
                              common.formatCurrency(montht),
                              common.formatCurrency(montht * 0.18),
                              common.formatCurrency(mont)
                          ]
                      ]
                    : [[common.formatCurrency(montht), common.formatCurrency(montht * 0.18), common.formatCurrency(mont)]]
            });

            var finalY = doc.lastAutoTable.finalY;
            if (finalY > 217) {
                doc.addPage();
            }
            const pageCount = doc.internal.getNumberOfPages();
            for (var u = 1; u <= pageCount; u++) {
                doc.setPage(u);
                doc.setFontSize(10);
                doc.text('Page ' + String(u) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
            }
            doc.text('Arrêté à la somme de:', 15, 229);
            doc.setFontSize(8);
            doc.text(NumberToLetter(Math.round(mont)).toUpperCase() + ' FCFA', 15, 236);
            doc.rect(14, 231, width - 28, 8);
            doc.setFontSize(10);
            doc.text('Visa direction:', 15, 246);
            doc.text('Visa client:', 135, 246);
            doc.setFontSize(8);
            doc.setLineWidth(1.5);
            setLoad(false);
            doc.setFontSize(8);
            doc.setTextColor(254, 0, 0);
            // doc.text('* Aucun produit ne peut être retourner 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);
            doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 3);

            //doc.autoPrint({variant: 'non-conform'});
            doc.save('proforma.pdf');
        }
    }

    const exportCSV = () => {
        //--------------- EXPORT VERS EXCEL ------------------
        const raw_data = gridRef.current.data.sort(GetSortOrder('nomclient'));
        /* flatten objects */
        const rows = [];
        raw_data.map((row, index) => {
            rows.push({
                client: row.nomclient,
                nofact: row.nofact,
                datefact: dateformat(row.datefact, 'dd-mm-yyyy'),
                noprof: row.noprof,
                dateprof: dateformat(row.dateprof, 'dd-mm-yyyy'),
                prix_ttc: row.montantfacture[2],
                reglement: row.montantreglemnt,
                reste: row.montantfacture[2] - row.montantreglemnt
            });
        });

        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mes factures');
        /* fix headers */
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [['Clients', 'N° facture', 'Date facture', 'N° proforma', 'Date proforma', 'Montant TTC', 'Montant reglé', 'Reste']],
            { origin: 'A1' }
        );
        /* calculate column width */
        const max_width = rows.reduce((w, r) => Math.max(w, r.client.length), 10);
        worksheet['!cols'] = [{ wch: max_width }];
        XLSX.writeFile(workbook, 'proforma.xlsx');
    };

    //-------------IMPRIMER LES LISTE ----------------
    function printListeSelect() {
        if (window.confirm('Voulez-vous la version détaillée ?') === true) {
            printListeDetail();
        } else {
            printListe();
        }
    }
    function printListe() {
        if (gridRef.current.data.length <= 0) {
            setMsg('Aucune donnée à imprimer');
            setIsSave(true);
            setMsgravity('danger');
            return;
        }
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });
        var width = doc.internal.pageSize.getWidth();
        const data = [];
        let mont = 0;
        let reglement = 0;
        let reste = 0;
        let totalTva = 0;
        // common.ipapi == 'https://192.168.8.109:81' || common.ipapi == 'https://api.tracky-entrepot.com'
        //     ? doc.addImage(common.logo, 'png', 14, 10, 30, 30)
        //     : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);
        doc.setFontSize(16);
        common.ipapi == 'https://192.168.8.109:81' || common.ipapi == 'https://api.tracky-entrepot.com'
            ? doc.text('DEPOT', 90, 14)
            : doc.text('HR MOTORS', 90, 14);
        doc.setFontSize(12);
        doc.setFillColor(61, 43, 31);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setTextColor(0, 0, 0);
        doc.text('LISTE DES FACTURES ET DEVIS CLIENTS', 90, 22);

        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);

        // doc.text("Période du: "+dateformat(datedeb || gridRef.current.data[gridRef.current.data.length-1].datesort,"dd-mm-yyyy")+" Au : "+dateformat(datefin || gridRef.current.data[0].datesort,"dd-mm-yyyy") ,65,32)
        gridRef.current.data.forEach((row) => {
            mont += row.montantfacture[2];
            reglement += row.montantreglemnt;
            reste += row.montantfacture[2] - row.montantreglemnt;
            totalTva += row.montantfacture[1];
            data.push([
                { content: row.nomclient },
                { content: row.nofact !== null ? row.nofact : '' },
                { content: row.datefact !== null ? dateformat(row.datefact, 'dd-mm-yyyy') : '' },
                { content: row.noprof ? row.noprof : '' },
                { content: dateformat(row.dateprof, 'dd-mm-yyyy') },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[0]) },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[1]) },

                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[2]) },

                {
                    content: new Intl.NumberFormat('de-DE', {
                        style: 'decimal',
                        currency: 'CFA'
                    }).format(row.montantreglemnt)
                },

                {
                    content: new Intl.NumberFormat('de-DE', {
                        style: 'decimal',
                        currency: 'CFA'
                    }).format(row.montantfacture[2] - row.montantreglemnt)
                }
            ]);
        });
        data.push([
            { content: 'TOTAL', colSpan: 6, styles: { fontStyle: 'bold', fontSize: 12 } },
            {
                content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(totalTva),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },

            {
                content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(mont),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat('de-DE', {
                    style: 'decimal',
                    currency: 'CFA'
                }).format(reglement),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat('de-DE', {
                    style: 'decimal',
                    currency: 'CFA'
                }).format(reste),
                styles: { fontStyle: 'bold', fontSize: 12 }
            }
        ]);
        doc.autoTable({
            styles: {
                fillColor: [61, 43, 31],
                textColor: [0, 0, 0],
                halign: 'center',
                fontSize: 10,
                cellPadding: 0.75
            },
            columnStyles: {
                0: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                1: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                2: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                3: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                4: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                5: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                6: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                7: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                8: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                9: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                10: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                }
            },
            theme: 'grid',
            startY: 35,
            fontSize: 6,
            head: [
                [
                    'Clients',
                    'N° facture',
                    'Date facture',
                    'N° proforma',
                    'Date proforma',
                    'Montant HT',
                    'Montant TVA',
                    'Montant TTC',
                    'Montant reglé',
                    'Reste'
                ]
            ],
            body: data
        });
        const pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text('Page ' + String(i) + ' sur ' + String(pageCount), 210 - 55, 200, null, null, 'right');
        }
        doc.setFontSize(8);
        doc.setTextColor(254, 0, 0);
        // doc.text('* Aucun produit ne peut être retourné 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);
        doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 3);

        doc.save('liste proforma.pdf');
    }

    function printListeDetail() {
        // var voirprix = false;
        // if (window.confirm("Voulez-vous afficher le prix d'achat") === true) {
        //     voirprix = true;
        // }
        if (gridRef.current.data.length <= 0) {
            return;
        }
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });
        var width = doc.internal.pageSize.getWidth();
        const data = [];
        var totalachat = 0;
        let mont = 0;
        let qte = 0;
        var benefice = 0;
        var totalremiser = 0;
        let qteretour = 0;
        var tremise = 0;
        var tvaremise = 0;
        let totalTva = 0;
        var totalRemise = 0;
        common.societe === 0 ? doc.addImage(common.logo, 'png', 14, 10, 30, 30) : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);

        doc.setFontSize(16);
        doc.setFontSize(12);
        doc.setFillColor(61, 43, 31);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setTextColor(0, 0, 0);
        doc.text('LISTE DES FACTURES AVEC DETAILS', 90, 22);
        doc.setTextColor(0, 0, 0);
        var datavar = [...gridRef.current.data.sort(GetSortOrder('datefact'))];

        var len = datavar.length;
        var i = 0;
        var datedeb = dateformat(datavar[0].dateprof, 'dd-mm-yyyy');
        var datefin = dateformat(datavar[datavar.length - 1].dateprof, 'dd-mm-yyyy');
        datavar.forEach((row, index) => {
            if (len > i + 1) {
                if (i === 0) {
                    data.push([
                        {
                            content:
                                'Client: ' +
                                row.nomclient +
                                ' / proforma N°: ' +
                                row.noprof +
                                ' / Date: ' +
                                dateformat(row.dateprof, 'dd-mm-yyyy'),
                            colSpan: 8,
                            styles: { fontStyle: 'bold', fontSize: '8' }
                        }
                    ]);
                } else if (datavar[i].noprof !== datavar[i - 1].noprof) {
                    data.push([
                        {
                            content:
                                'Client: ' +
                                row.nomclient +
                                ' / proforma N°: ' +
                                row.noprof +
                                ' / Date: ' +
                                dateformat(row.dateprof, 'dd-mm-yyyy'),
                            colSpan: 8,
                            styles: { fontStyle: 'bold', fontSize: '8' }
                        }
                    ]);
                }
            } else {
                data.push([
                    {
                        content:
                            'Client: ' +
                            row.nomclient +
                            ' / proforma N°: ' +
                            row.noprof +
                            ' / Date: ' +
                            dateformat(row.datefact, 'dd-mm-yyyy'),
                        colSpan: 8,
                        styles: { fontStyle: 'bold', fontSize: '8' }
                    }
                ]);
            }
            var remise = 0;
            var realqte = 0;
            var qteprix = 0;
            var tqteprix = 0;
            var remiseCumul = 0;
            row.lignefacture.forEach((lsort) => {
                var prixachat = lsort.pivot.prix_achat;

                realqte = lsort.pivot.quantite;
                qteprix = lsort.pivot.prix * realqte;
                mont += qteprix;
                qte += lsort.pivot.quantite;
                remise = qteprix * (lsort.pivot.remise / 100);
                remiseCumul += qteprix * (lsort.pivot.remise / 100);
                benefice += qteprix - realqte * prixachat;
                totalremiser += qteprix - remise;
                totalachat += prixachat * realqte;
                var prixremiser = qteprix - remise;
                // totalTva += row.sitva == 1 ? 0 : prixremiser * 0.18;

                // realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                // qteprix = lsort.pivot.prix * realqte;
                tqteprix += qteprix;
                // mont += qteprix;
                // qte += realqte;
                // remise = qteprix * (lsort.pivot.remise / 100);
                // remiseCumul += qteprix * (lsort.pivot.remise / 100);
                // tremiseligne += remise;
                // benefice += qteprix - remise - realqte * prixachat;
                // totalremiser += qteprix - remise;
                // totalachat += prixachat * realqte;
                // var prixremiser = qteprix - remise;
                // totalTva += row.sitva == 1 ? 0 : prixremiser * 0.18;

                data.push([
                    lsort.qrbarre,
                    lsort.descriptionart,
                    new Intl.NumberFormat(['ban', 'id']).format(realqte).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(prixachat)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(prixachat * realqte)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(remise)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(lsort.pivot.prix)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(qteprix)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(prixremiser)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(row.sitva == 1 ? 0 : prixremiser * 0.18)).replace('.', ' '),
                    new Intl.NumberFormat(['ban', 'id']).format(Math.round(benefice - totalRemise)).replace('.', ' ')
                ]);
                // }
            });
            i++;
            // tremise +=
            //     row.remise_main > 0 ? (row.type_remise > 0 ? row.remise_main : (tqteprix - remiseCumul) * (row.remise_main / 100)) : 0;
            if (row.lignefacture.length > 0) {
                tremise = row.remise_main > 0 ? (row.type_remise > 0 ? row.remise_main : tqteprix * (row.remise_main / 100)) : 0;
                totalRemise += remiseCumul + tremise;
            }
            totalTva += row.sitva == 1 ? 0 : (tqteprix - remiseCumul - tremise) * 0.18;

            tvaremise +=
                row.remise_main > 0
                    ? row.type_remise > 0
                        ? row.remise_main * 0.18
                        : (tqteprix - remiseCumul) * (row.remise_main / 100) * 0.18
                    : 0;
        });
        if (Object.keys(filterDate).length === 1) {
            if ((filterDate.start === undefined || filterDate.start === '') && filterDate.end !== '') {
                doc.text('Période du: ' + datedeb + ' Au : ' + filterDate.end, 65, 32);
            } else if ((filterDate.end === undefined || filterDate.end === '') && filterDate.start !== '') {
                doc.text('Période du: ' + filterDate.start + ' Au : ' + datefin, 65, 32);
            } else {
                doc.text('Période du: ' + datedeb + ' Au : ' + datefin, 65, 32);
            }
        } else if (Object.keys(filterDate).length === 2) {
            if (filterDate.start !== '' && filterDate.end !== '') {
                doc.text('Période du: ' + filterDate.start + ' Au : ' + filterDate.end, 65, 32);
            } else if (filterDate.start === '' && filterDate.end === '') {
                doc.text('Période du: ' + datedeb + ' Au : ' + datefin, 65, 32);
            } else if (filterDate.start !== '' && filterDate.end === '') {
                doc.text('Période du: ' + filterDate.start + ' Au : ' + datefin, 65, 32);
            } else if (filterDate.start === '' && filterDate.end !== '') {
                doc.text('Période du: ' + datedeb + ' Au : ' + filterDate.end, 65, 32);
            } else {
                doc.text('Période du: ' + datedeb + ' Au : ' + datefin, 65, 32);
            }
        } else {
            doc.text('Période du: ' + datedeb + ' Au : ' + datefin, 65, 32);
        }

        data.push([
            { content: 'TOTAL', styles: { fontStyle: 'bold', fontSize: 12 } },
            '',
            { content: new Intl.NumberFormat(['ban', 'id']).format(qte).replace('.', ' '), styles: { fontStyle: 'bold', fontSize: 12 } },
            '',
            {
                content: new Intl.NumberFormat(['ban', 'id']).format(totalachat).replace('.', ' '),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            '',
            '',
            {
                content: new Intl.NumberFormat(['ban', 'id']).format(Math.round(mont)).replace('.', ' '),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat(['ban', 'id']).format(Math.round(mont - totalRemise)).replace('.', ' '),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat(['ban', 'id']).format(Math.round(totalTva)).replace('.', ' '),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat(['ban', 'id']).format(Math.round(benefice)).replace('.', ' '),
                styles: { fontStyle: 'bold', fontSize: 12 }
            }
        ]);
        doc.autoTable({
            styles: {
                fillColor: [206, 206, 206],
                textColor: [4, 4, 4],
                halign: 'center',
                fontSize: 10,
                cellPadding: 0.75
                // lineColor: [0, 0, 0]
            },
            columnStyles: {
                0: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    // cellWidth: 25,
                    fontSize: 8
                },
                1: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                    // cellWidth: 40
                },
                2: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                    // cellWidth: 20
                },
                3: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                    // cellWidth: 40
                },
                4: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                5: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                6: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                7: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                8: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                9: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                10: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                }
            },
            theme: 'grid',
            startY: 35,
            fontSize: 6,

            head: [
                [
                    'Code',
                    'Articles',
                    'Qté liv',
                    'Prix achat',
                    'Total achat',
                    'Remise',
                    'Prix vente',
                    'Total vente',
                    'Total remisé',
                    'TVA',
                    'Bénéfice'
                ]
            ],
            body: data
        });

        const pageCount = doc.internal.getNumberOfPages();
        for (var u = 1; u <= pageCount; u++) {
            doc.setPage(u);
            doc.setFontSize(10);
            doc.text('Page ' + String(u) + ' sur ' + String(pageCount), 210 - 55, 200, null, null, 'right');
        }
        doc.save('Listefacture.pdf');
    }

    return (
        <div>
            {showAddLiv ? (
                <AddSortie
                    setShowAddLiv={setShowAddLiv}
                    show={showAddLiv}
                    setIsSave={setIsSave}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    data={datafacture}
                    getProforma={getProforma}
                    getFacture={getFacture}
                    keys={keys}
                />
            ) : (
                <></>
            )}
            {showFactureForm ? (
                <AddFacture
                    setShowAdd={setShowFactureForm}
                    show={showFactureForm}
                    setIsSave={setIsSave}
                    // isSave={isSave}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    setActualise={setActualise}
                    actualise={actualise}
                    ids={ids}
                    statesParent={statesParent}
                    source="proforma"
                />
            ) : (
                <></>
            )}

            {showFilterModal ? (
                <FilterModale
                    setShowFilterModals={setShowFilterModals}
                    showFilterModal={showFilterModal}
                    keys={keys}
                    setMsg={setMsg}
                    setIsSave={setIsSave}
                    setMsgravity={setMsgravity}
                    setLoad={setLoad}
                    load={load}
                    handleClose={handleClose}
                    setDatasProf={setDatasProf}
                    paramShow={paramShow}
                    setDataFact={setDatasProf}
                />
            ) : (
                <></>
            )}
            {showFactureModal ? (
                <FacturerModal
                    show={showFactureModal}
                    setShowFactureModal={setShowFactureModal}
                    getFacture={getFacture}
                    getProforma={getProforma}
                    datafacture={datafacture}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    setIsSave={setIsSave}
                    setLoad={setLoad}
                />
            ) : (
                <></>
            )}
            <NavMenu
                printListe={printListeSelect}
                selected={selected}
                setShowAddOrEdit={setShowAddOrEdit}
                exportCSV={exportCSV}
                setShowFilterModals={setShowFilterModals}
            />
            <ReactDataGrid
                idProperty="id"
                handle={setGridRef}
                style={gridStyle}
                loading={isLoading}
                reorderColumns={false}
                pagination
                selected={selected}
                // checkboxColumn
                // onSelectionChange={onSelectionChange}
                pageSizes={[200, 400, 600, 800, rows.length]}
                defaultLimit={400}
                showHoverRows={true}
                editable={true}
                showColumnMenuTool={false}
                defaultFilterValue={filterValuePro}
                columns={columnPro}
                dataSource={rows}
            />
        </div>
    );
}

export default IndexProforma;
